import { computed, readonly, ref } from 'vue'
import api from '@/services/api'

const stats = ref(null)
const loading = ref(false)
const lastUpdatedAt = ref(null)
let inFlight = null
let pollTimer = null

const waitingForUs = computed(() => Number(stats.value?.waiting_for_us ?? stats.value?.open ?? 0))
const overdue = computed(() => Number(stats.value?.overdue ?? 0))
const unassigned = computed(() => Number(stats.value?.unassigned ?? 0))

async function refresh({ force = false } = {}) {
  const isFresh = lastUpdatedAt.value && Date.now() - lastUpdatedAt.value.getTime() < 15_000
  if (!force && isFresh) return stats.value
  if (inFlight) return inFlight

  loading.value = true
  inFlight = api.get('/support/stats')
    .then(({ data }) => {
      stats.value = data?.data?.stats ?? data?.data ?? data ?? {}
      lastUpdatedAt.value = new Date()
      return stats.value
    })
    .catch((error) => {
      console.error('support attention stats', error)
      return stats.value
    })
    .finally(() => {
      loading.value = false
      inFlight = null
    })

  return inFlight
}

function startPolling(intervalMs = 60_000) {
  refresh()
  if (!pollTimer) pollTimer = window.setInterval(() => refresh({ force: true }), intervalMs)
}

function stopPolling() {
  if (pollTimer) window.clearInterval(pollTimer)
  pollTimer = null
}

export function useSupportAttention() {
  return {
    stats: readonly(stats),
    loading: readonly(loading),
    lastUpdatedAt: readonly(lastUpdatedAt),
    waitingForUs,
    overdue,
    unassigned,
    refresh,
    startPolling,
    stopPolling,
  }
}
